module.exports = __webpack_public_path__ + "static/media/Mask Group 116.2fa2d021.png";